import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutingService } from '@core/routing/app-routing.service';
import { VerifyAccountFirstLoginService } from '@features/auth/core/domain/account-first-login/verify-account-first-login.service';
import { SSOAccountFirstLoginFormOTPService } from '../../account-first-login-otp.service';
import { finalize, Subject } from 'rxjs';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { CountdownButtonDirective } from '@features/auth/shared/directives/coutdown-and-disable.directive';
import { PHONE_NUMBER_PATTERN } from '@features/auth/shared/helpers/phone-number-pattern';
import { FORM_CONTROL_NUMBER_PATTERN } from '@features/auth/shared/helpers/only-number.pattern';
import { navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';
import { SSOVerifyAccountFirstLoginService } from '@features/auth/core/domain/sso-account-first-login/sso-verify-account-first-login.service';
import { WEB_ROUTE_SSO_XAC_MINH_LAN_DAU } from '@features/auth/const';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CountdownButtonDirective,
    TranslocoModule,
  ],
  selector: 'app-sso-auth-verify-phone',
  templateUrl: './verify-phone.component.html',
  styleUrls: ['./verify-phone.component.css']
})
export class SSOVerifyPhoneComponent implements OnInit, OnDestroy {
  private readonly appRouting = inject(AppRoutingService);
  private readonly routing = inject(Router);
  private readonly service = inject(SSOVerifyAccountFirstLoginService);
  private readonly otpFormService = inject(SSOAccountFirstLoginFormOTPService);
  private readonly formBuilder = inject(FormBuilder);

  public phoneForm!: FormGroup;
  public showLoading: boolean = false;
  destroy$$ = new Subject<void>();
  displayErrorMessage: string = '';

  ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.complete();
  }

  constructor() { }

  ngOnInit() {
    this.phoneForm = this.formBuilder.group({
      countryCode: [
        '+84',
        Validators.compose([
        ]),
      ],
      phoneNumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(FORM_CONTROL_NUMBER_PATTERN)
        ]),
      ],
    });
  }

  get formControls() {
    return this.phoneForm.controls;
  }

  removeZeroPhoneNumber(phone: string): string {
    if (phone.startsWith('0')) {
      return phone.substring(1);
    }
    return phone;
  }

  onVerify() {
    if (this.phoneForm.invalid) {
      this.phoneForm.markAllAsTouched();
      return;
    }

    const { phoneNumber, countryCode } = this.phoneForm.getRawValue();
    const phone = countryCode + this.removeZeroPhoneNumber(phoneNumber);

    this.showLoading = true;
    this.phoneForm.disable();

    this.service
      .verifyPhoneNumber(phone, {})
      .pipe(
        finalize(() => {
          this.showLoading = false;
          this.phoneForm.enable();
        })
      )
      .subscribe({
        next: (value) => {
          this.otpFormService.setVerifyPhoneNumber(phone);
          this.otpFormService.setSwitchViewVerifyCodeToPhone();
        },
        error: (err) => {
          console.error(err);
          this.displayErrorMessage = err.message;
        },
      });
  }

  goBack() {
    // this.routing.navigate([WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
    navigateWithQueryParams(this.routing, [WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
    // this.appRouting.navigateToLoginPage();
  }
}
